import React, { useRef } from 'react'
import * as researcherFormType from './researcherFormTypes'
import useLookupService from '../../../../services/lookup/useLookupService'
import { useForm } from 'react-final-form'
import useTranslate from '../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../stores/manageProject/useManageProjectStore'

const useResearcherForm = (props: researcherFormType.UseResearcherFormType) => {
    const { isEditAfterReview } = props

    const form = useForm()
    const translate = useTranslate()
    const callLookup = useLookupService()
    const manageProjectStore = useManageProjectStore()

    const [categoryProject, setCategoryProject] = React.useState<researcherFormType.OptType[]>([])
    const [faculty, setFaculty] = React.useState<researcherFormType.OptType[]>([])
    const [researcherType, setResearcherType] = React.useState<researcherFormType.OptType[]>([])
    const [titleNameList, setTitleNameList] = React.useState<researcherFormType.OptType[]>([])
    const [academicPositionList, setAcademicPositionList] = React.useState<researcherFormType.OptType[]>([])
    const [educationList, setEducationList] = React.useState<Array<researcherFormType.OptType>>([])

    const [isNeedEditForm, setIsNeedEditForm] = React.useState<boolean>(true)
    const [isShowAcademicPosition, setIsShowAcademicPosition] = React.useState<boolean>(false)
    const lookupFacultyResponse = useRef<Array<Partial<{ id: number; name_th: string; name_en: string; irb: number }>>>(
        [],
    )

    React.useEffect(() => {
        getCategoryProject()
        getFaculty()
        getEducationLevel()
        getResearcherType()
        getTitleName()
        getAcademicPosition()
        getEducationLevel()
    }, [translate.languageStore.currentLanguage])

    React.useEffect(() => {
        if (isEditAfterReview || manageProjectStore?.projectData?.isFlowApproveWithComment) {
            if (
                manageProjectStore.projectData?.previousIsNeedEditForm !== null &&
                manageProjectStore.projectData?.previousIsNeedEditForm !== undefined
            ) {
                setIsNeedEditForm(manageProjectStore.projectData?.previousIsNeedEditForm)
            }
        }
    }, [manageProjectStore.projectData?.submittedID ?? null])

    React.useEffect(() => {
        const formVal = form.getState().values
        if (formVal?.researcherType?.value === '1') {
            setIsShowAcademicPosition(false)
        } else {
            setIsShowAcademicPosition(true)
        }
    }, [form.getState().values])

    const getEducationLevel = async () => {
        const res = await callLookup.getEducationLevel()
        const formatData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setEducationList(formatData)
    }

    const getCategoryProject = async () => {
        const res = await callLookup.callProjectSubmitTypeLut()
        lookupFacultyResponse.current = res.result
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setCategoryProject(formatedData)
    }

    const getFaculty = async () => {
        const res = await callLookup.callFacultyLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
                irb: `${itm.irb}`,
            }
        })

        setFaculty(formatedData)
    }

    const getResearcherType = async () => {
        const res = await callLookup.callResearcherTypeLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setResearcherType(formatedData)
    }

    const getTitleName = async () => {
        const res = await callLookup.callTitleNameLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setTitleNameList(formatedData)
    }

    const getAcademicPosition = async () => {
        const res = await callLookup.callAcademicPositionLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        const academicPosition = [...formatedData]

        setAcademicPositionList(academicPosition)
    }

    const addResearcher = () => {
        const mutators = form.mutators
        mutators.push('coResearcher', { researcherRoleTypeId: 2 })
    }

    return {
        researcherType,
        titleNameList,
        academicPositionList,
        educationLevelLut: educationList,
        isNeedEditForm,
        isShowAcademicPosition,
        addResearcher,
    }
}

export default useResearcherForm
